import type { CSSProperties } from "react";
import { Toaster as Sonner, type ToasterProps } from "sonner";

/**
 * Toaster wired to the portal's design tokens. `theme="system"` lets sonner
 * follow the OS color scheme, matching our prefers-color-scheme theming.
 */
function Toaster(props: ToasterProps) {
  return (
    <Sonner
      theme="system"
      position="bottom-center"
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border-strong)",
          "--border-radius": "12px",
        } as CSSProperties
      }
      toastOptions={{
        style: { boxShadow: "var(--shadow-portal)" },
      }}
      {...props}
    />
  );
}

export { Toaster };
